import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { FiMail, FiPhone } from 'react-icons/fi';
import { FaRegUser } from 'react-icons/fa';
import { Collaborator } from '../../../domain/collaborator';
import { Role, RoleToString } from '../../../domain/Role';
import { CiShop, CiShoppingTag } from 'react-icons/ci';
import { PiIdentificationCardLight } from 'react-icons/pi';
import { LiaUserShieldSolid } from 'react-icons/lia';

interface UserCardProps {
  user: Collaborator;
}

const EMPTY_VALUE = '-';

const toDisplayNames = (names?: string | string[]): string => {
  const joined = Array.isArray(names) ? names.join(', ') : names;
  return joined || EMPTY_VALUE;
};

export const UserCard = (props: UserCardProps) => {
  const { user } = props;

  return (
    <Box key={user.id} borderWidth="1px" borderColor="neutral.200" borderRadius="xl" padding="xxl"
         marginBottom="xl" marginRight="l">
      <Text fontSize="l" fontWeight="medium"
            textTransform="capitalize">{user.lastname}, {user.firstname}</Text>

      <Flex alignItems="center" justifyContent="space-between" marginTop="xl" wrap="wrap">
        <ItemDescription icon={<FiMail />} value={user.email} />
        {user.$type === 'collaborator' &&
          <>
            <ItemDescription icon={<FiPhone />} value={user.phone_number || '-'} />
            <ItemDescription icon={<PiIdentificationCardLight />} value={'Documento: ' + (user.document_number || '-')} />
          </>
        }
      </Flex>

      <Flex alignItems="center" justifyContent="space-between" marginTop="xl" wrap="wrap">
        <ItemDescription icon={<CiShop />} value={toDisplayNames(user.merchant_name)} />
        {user.$type !== Role.auditor ?
          <>
            <ItemDescription icon={<CiShoppingTag />} value={toDisplayNames(user.branch_name)} />
            <ItemDescription icon={<FaRegUser />} value={RoleToString(user.$type)} />
          </>
          :
          <ItemDescription icon={<LiaUserShieldSolid />} value={RoleToString(user.$type)} />
        }
      </Flex>
    </Box>
  );
};

interface ItemDescriptionProps {
  icon: React.ReactNode;
  value: string;
}

const ItemDescription = ({ icon, value }: ItemDescriptionProps) => {
  return <Flex alignItems="center" color="neutral.800">
    {icon}
    <Text marginLeft="l" width="20em">{value}</Text>
  </Flex>;
};
